exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center-full[data-v-4de8ebf6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.center-full[data-v-4de8ebf6],.full[data-v-4de8ebf6]{width:100%;height:100%}.welcome-title[data-v-4de8ebf6]{font-size:50px}", ""]);

// exports
